import { Client, PrivateKey, Wallet } from '@hashgraph/sdk';
import { SigningStrategy } from './SigningStrategy';
import { NetworkConfig } from './types';
import { createClient } from './ClientFactory';

export class LocalKeyStrategy implements SigningStrategy {
  private wallet: Wallet;
  private client: Client;
  private accountId: string;
  private publicKey: string;

  constructor(privateKey: PrivateKey, accountId: string, config: NetworkConfig) {
    this.accountId = accountId;
    this.publicKey = privateKey.publicKey.toStringDer();
    this.client = createClient(config);
    this.client.setOperator(accountId, privateKey);
    this.wallet = new Wallet(accountId, privateKey);
  }

  getSigner() {
    return this.wallet;
  }

  getAccountId(): string {
    return this.accountId;
  }

  getPublicKey(): string {
    return this.publicKey;
  }

  getClient(): Client {
    return this.client;
  }
}
